export default "__VITE_ASSET__V9wuz8l7__"